module.exports = __webpack_public_path__ + "img/linkedin_square.2df0a646.svg";